import {
  ElementDefinition,
  Element,
  ElementMap,
} from "@easy-email-pro-core/typings";
import { blockMap as internalBlockMap } from "@easy-email-pro-core/blocks";
import { EditorAuth } from "./EditorAuth";

const blocksMap = { ...internalBlockMap } as ElementMap;

class BlockManagerCore {
  public registerBlocks(blocks: Array<ElementDefinition<any>>) {
    blocks.forEach((block) => {
      (blocksMap as any)[block.type] = block;
    });
  }

  public getBlockByType<T extends Element["type"]>(type: T) {
    if (blocksMap[type] && !internalBlockMap[type]) {
      const isEnabled = EditorAuth.getFeatureEnabled("CUSTOM_BLOCK");
      if (!isEnabled) {
        throw new Error(`Current plan do not support custom block`);
      }
    }

    // if (!blocksMap[type]) {
    //   console.error(`${type} not register`);
    // }

    return blocksMap[type];
  }

  public getBlocks() {
    return Object.values(blocksMap);
  }

  public getBlockTitle(blockData: Element): string {
    if (blockData.title) return blockData.title;

    const blockName = this.getBlockByType(blockData.type)?.name || "";
    return blockName;
  }
}

const BlockManager = Object.freeze(new BlockManagerCore());

export { BlockManager };
